// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2ToGp","question":"Question_question__2Y2mb","description":"Question_description__152aX"};